import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs';
import { ConfigService } from '../config.service';
import { DataTransform, DateField } from './dataTransformFunctions';
import { MTCustomerLink } from './types/recruiting';

@Injectable({
  providedIn: 'root'
})
export class MarketingTouchLinkService {

  private readonly dateFields: DateField<MTCustomerLink>[] = [{dateType: "utc", fieldName: "timestamp"}]

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) { }

  getForCustomer(customerId: number) {
    return this.http.get<MTCustomerLink[]>(`${this.config.dataApiUrl}/customers/${customerId.toString()}/marketing-touches`).pipe(
      switchMap(mtLinks => {
          return DataTransform.replaceDatesArray<MTCustomerLink>(mtLinks, this.dateFields)
      })
    )
  }

}
